import React from 'react';

export default function Problems() {
  return <div>Problems page</div>;
}
